import * as moment from 'moment';


export class CommonHelper {

	constructor() { }

	static MOBILE_REGEX = /^((?:)(3)[0-9]{9})$/;
	static PHONE_REGEX = /^(([0-9]{10}))$/;
	static FORM_DATE_REGEX = /[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
	static SERVICE_DATE_REGEX = /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}/;
	static EMAIL_REGEX = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;;
	static SECONDARY_EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|edu.pk)\b/;
	static CNIC_REGEX = /^[1-4]{1}[0-9]{4}(-)?[0-9]{7}(-)?[0-9]{1}$/;

	/*
		Convert file to byte[]
		@param: file: File
		@param: callback: Function | its a callback function
		@return: Uint8Array
	*/
	static fileToBytes = (file: File, callback: Function) => {
		let reader = new FileReader();
		reader.readAsArrayBuffer(file[0]);
		reader.onloadend = () => {
			let unitArray = new Uint8Array((reader as any).result)
			let bytes = Array.prototype.slice.call(unitArray);
			callback(bytes, file[0].type);
		};
	};

	/*
		Convert file to byte[]
		@param: file: FileList
		@param: callback: Function | its a callback function
		@return: Uint8Array
	*/
	static filesToBytes = (files: FileList, bytesCallback: Function, callback: Function) => {

		let processed = 0;
		[].forEach.call(files, (file: File, index) => {
			let reader = new FileReader();
			reader.readAsArrayBuffer(file);
			reader.onloadend = () => {

				processed++;
				let unitArray = new Uint8Array((reader as any).result)
				let bytes = Array.prototype.slice.call(unitArray);
				bytesCallback(bytes, index);

				// When all async operation completed then call final callback function
				if (processed === files.length) {
					callback();
				}

			}
		});
	};

	/*
		Calculate rating star width in %
		@param: rating: number
		@return: number
	*/
	static calcRatingWidth = (rating: number) => {
		return (rating * 100 / 5);
	}

	/*
		Mark from controls state is touched
		@param: formGroup: FormGroup | NgForm
	*/
	static markFormGroupTouched = (formGroup) => {
		(<any>Object).values(formGroup.controls).forEach(control => {
			control.markAsTouched();

			if (control.controls) {
				CommonHelper.markFormGroupTouched(control);
			}
		});
	};

	/*
		Mark from controls state is untouched
		@param: formGroup: FormGroup | NgForm
	*/
	static markFormGroupUnTouched = (formGroup) => {
		(<any>Object).values(formGroup.controls).forEach((control) => {
			control.markAsUntouched();
			if (control.controls) {
				CommonHelper.markFormGroupUnTouched(control);
			}
		});
	};


	/*
	   Remove empty property in object
	   @param: obj: Object | Any
   */
	static convertUndefinedToNull(obj) {
		for (var prop in obj) {
			if (obj[prop] === undefined) {
				obj[prop] = null;
			}
		}
	}

	/*
		Remove empty property in object
		@param: obj: Object | Any
	*/
	static removeEmptyPropFromObject(obj) {
		for (var prop in obj) {
			if (obj[prop] === null || obj[prop] === undefined || obj[prop] === '') {
				delete obj[prop];
			}
		}
	}

	/*
		Remove list of properties in object
		@param: properties: [] | Any, obj: Object | any
	*/
	static removePropArrFromObject(propArr, obj) {
		propArr.forEach(property => {
			delete obj[property]
		});
	}

	/*
	   Append non existent  properties of source into target object
	   @param: properties: [] | Any, obj: Object | any
   */
	static unionPropFromSourceToTarget(source, target) {
		for (let key in source) {
			if (!target[key] && target[key] != "")
				target[key] = source[key];
		}
	}

	/*
	   Append non existent form properties of source into target object
	   @param: properties: [] | Any, obj: Object | any
   */
	static unionPropFromFormToObject(formControls, myObj) {
		for (let key in formControls) {
			if (!myObj[key] && myObj[key] != "")
				myObj[key] = null;
		}
	}


	static valuesFromFormToModel(model, form) {
		for (var key of Object.keys(form)) {
			for (var modelKeys of Object.keys(model)) {
				if (key == modelKeys && form[key] != null) {
					model[modelKeys] = form[key]
				}
				else {
				}
			}
		}

	}

	static valuesFromServiceToForm(serviceData, formData) {
		var formKeys = Object.keys(formData)
		for (var serviceKeys of Object.keys(serviceData)) {
			if (formData.hasOwnProperty(serviceKeys)) {

			}
			else {
				delete serviceData[serviceKeys]
			}
		}

	}


	static setNullPropertiesToFalse(rowModel) {
		for (var key in rowModel) {
			//  if(rowModel[key] == null && typeof(key) == "boolean"){
			//      rowModel[key]=false
			//  }
		}
	}


	static getControlsOfForm(form) {
		// console.log(Object.keys(form))
	}

	/* conversion of datatypes */
	static dataTypeConversion(model, payload) {
		for (let key in model) {
			if (typeof (model[key]) != typeof (payload[key])) {
				// console.log(typeof (model[key]))
			}

		}
	}

	static getFormFieldStatus(Form) {
		for (let key in Form.controls) {
			// console.log('field name', key , 'field status', Form.controls[key].status)
		}
	}

	/*
		Get user current position
		@return: Position
	*/
	static getUserCurrentPosition(): Promise<any> {
		const options = {
			enableHighAccuracy: true,
			timeout: 5000,
			maximumAge: 0
		};
		if (navigator.geolocation) {
			return new Promise(function (resolve, reject) {
				navigator.geolocation.getCurrentPosition(resolve, reject, options);
			});
		} else {
			return new Promise((resolve) => {
				let coords = {
					latitude: 30.3753,
					longitude: 69.3451
				};
				resolve(coords);
			});
		}
	}


	/*
		Convert MimeType
		@param: mimeType: String
	*/
	static trimMimeType(mimeType: string): string {
		if (mimeType.indexOf("/"))
			return (mimeType.substring(mimeType.indexOf("/") + 1, mimeType.length));
		else
			return mimeType;

	}

	static removeCommaFromAddressField(address) {
		if (address.charAt(address.length - 1) == ",") {
			return address.slice(0, address.length - 1)
		}
	}

	static convertToFormDateFormat(date) {
		return date.substr(0, 10);
	}

	static convertToFormYearFormat(date) {
		return date.substr(0, 4);
	}

	static convertToServiceDateFormat(date) {
		return new Date(date).toISOString()
	}

	static convertUTCDateToLocalDateTime(date) {
		return new Date(date).toLocaleString().replace(',', '')
	}

	static convertAllDatesToFormDate(myObj) {
		for (let prop in myObj) {
			// Convert date string to form required format
			// "2019-03-28T10:36:04.521Z" -> "2019-03-28"
			if (prop.includes("date") || this.SERVICE_DATE_REGEX.test(myObj[prop])) {
				myObj[prop] = this.convertToFormDateFormat(myObj[prop])
			}
		}
	}

	static performAddition(...args: any[]): number {
		var result = 0
		for (var i = 0; i < args.length - 1; i++) {
			result += (args[i] ? parseFloat(args[i]) : 0)
		}
		return result;
		// giving no of arguments to be added , the last argument must be a control

	}

	static performSubtraction(...args: any[]): number {
		var result = (args[0] ? parseFloat(args[0]) : 0)
		for (var i = 1; i < args.length - 1; i++) {
			result -= (args[i] ? parseFloat(args[i]) : 0)
		}
		return result;
		// giving no of arguments to be subtracted , the last argument must be a control

	}

	static convertObjectToModelType(myObj, model) {

		for (let prop in model) {

			// convert strings to numbers, according to model
			if ((typeof model[prop] == "number" || prop.endsWith("CodeId") || prop.endsWith("Id")) && myObj[prop] && (myObj[prop] != "" || myObj[prop] == "")) {
				myObj[prop] = +myObj[prop]
			}

			// For checkboxes, default to false
			if (typeof model[prop] == "boolean" && !myObj[prop]) {
				myObj[prop] = false
			}

			// Convert date string to service required format
			// "2019-03-02" -> 2019-03-28T10:36:04.521Z

			if (prop.includes("date") || prop.includes("Date") || this.FORM_DATE_REGEX.test(myObj[prop])) {
				// IF USER HAS SET THE DATE
				if (this.FORM_DATE_REGEX.test(myObj[prop])) {
					myObj[prop] = this.convertToServiceDateFormat(myObj[prop]);
				} else {
					// myObj[prop] = null
				}
			}

		}
	}

	static setDeviations(deviationsObj, deviationsArr) {
		for (let obj of deviationsArr) {
			deviationsObj[obj.fieldName] = { msg: obj.errorMessage }
		}
	}


	// type = application/ms-excel
	// filename = testfile.xls
	// data = res.body
	static downloadFileFromBlob(data: any, type: string, filename: string) {
		var blob = new Blob([data], { type: type.toString() });
		var blobURL = window.URL.createObjectURL(blob);
		var anchor = document.createElement("a");
		anchor.download = filename;
		anchor.href = blobURL;
		anchor.click();
	}

	static convertFileToBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				let base64Str = reader.result.toString();
				let base64 = base64Str.substring(base64Str.indexOf(",") + 1, base64Str.length - 1)
				resolve(base64);
			};
			reader.onerror = error => reject(error);
		});
	}


	static downloadBase64Image(base64Data: string, fileName: string) {

		const contentType = "image/png";
		const sliceSize = 512;
		const byteCharacters = atob(base64Data);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		const blobData = new Blob(byteArrays, { type: contentType });

		if (window.navigator && window.navigator.msSaveOrOpenBlob) { //IE
			window.navigator.msSaveOrOpenBlob(blobData, fileName);
		} else { // chrome
			const blob = new Blob([blobData], { type: contentType });
			const url = window.URL.createObjectURL(blob);
			// window.open(url);
			const link = document.createElement('a');
			link.href = url;
			link.download = fileName;
			link.click();
		}

	}

	static openBase64Image(base64Data: string) {
		var image = new Image();
		image.src = "data:image/png;base64," + base64Data;
		var w = window.open("");
		w.document.write(image.outerHTML);
	}

	static delay(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	static getDateInFormat(format: string) {
		return moment().format(format);
	}

	static get100YrOldDateInFormat(format: string) {
		return moment().subtract(100, "years").format(format);
	}

	static changeDateFormat(value: string, format: string) {
		return moment(value).format(format);
	}

	static base64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
		const byteCharacters = atob(b64Data);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

		const blob = new Blob(byteArrays, { type: contentType });
		return blob;
	}

	static showPdf(formName, base64) {
		const linkSource = 'data:application/pdf;base64,' + base64;
		const downloadLink = document.createElement("a");
		const fileName = formName + ".pdf";

		downloadLink.href = linkSource;
		downloadLink.download = fileName;
		downloadLink.click();
	}

	static dateConverter(d) {
		let date: any;
		let month: any;
		if (d.getDate().toString().length < 2) {
			date = '0' + d.getDate().toString()
		} else {
			date = d.getDate().toString()
		}
		if ((d.getMonth() + 1).toString().length < 2) {
			month = '0' + (d.getMonth() + 1).toString()
		} else {
			month = (d.getMonth() + 1).toString()
		}
		const day = d.getFullYear().toString() + "-" + month + "-" + date;
		return day
	}

	static getDate(date): any {
		date = new Date(date)
		let month: any;
		let dated: any;
		if (date.getDate().toString().length < 2) {
			dated = '0' + date.getDate().toString()
		} else {
			dated = date.getDate().toString()
		}
		if ((date.getMonth() + 1).toString().length < 2) {
			month = '0' + (date.getMonth() + 1).toString()
		} else {
			month = (date.getMonth() + 1).toString()
		}
		let convertedDate = date.getFullYear() + "-" + month + "-" + dated;
		return convertedDate
	}

	static validate(f): boolean {
		if (f.status === 'VALID') {
			return true;
		}
	}

}
